import React, { useEffect, useReducer } from 'react'
import { useParams } from 'react-router-dom'
import { LoaderIcon } from 'src/Components'
import BreadCrumbs from 'src/Components/Authenticated/BreadCrumbs'
import { MainPage } from 'src/Components/My'
import { GetLocalText } from 'src/Helpers/TextHelpers'
import { t } from 'src/I18n'
import EventTicketForm from '../Form/EventTicketForm'
import { initialState, reducer, reducerActions } from './Reducer'

const EventTicketInsert: React.FC = () => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const actions = reducerActions(state, dispatch)
  const params = useParams<'eventId'>()
  useEffect(() => {
    actions.getEvent(params.eventId)
  }, [null])

  const { event, isSubmitting } = state

  const name = event !== undefined ? GetLocalText(event.Name) : ''
  const renderContent = () => {
    if (event === undefined) {
      return <LoaderIcon IsLoading={true} />
    }

    return (
      <>
        <EventTicketForm
          onSave={(data) => {
            actions.save(params.eventId, data)
          }}
          title={t.eventTicket.insert.title}
          isSubmitting={isSubmitting}
        />
      </>
    )
  }

  return (
    <>
      <MainPage>
        <BreadCrumbs
          currentPageTitle={t.eventTicket.insert.title}
          previousPages={[
            {
              to: `/event/details/${params.eventId}`,
              title: name, //name
            },
          ]}
        />
        {renderContent()}
      </MainPage>
    </>
  )
}

export default EventTicketInsert
